var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 18.06C4.04 18.06 0 14.02 0 9.06C0 4.1 4.04 0.0600014 9 0.0600014C13.96 0.0600014 18 4.1 18 9.06C18 14.02 13.96 18.06 9 18.06ZM9 1.56C4.86 1.56 1.5 4.92 1.5 9.06C1.5 13.2 4.86 16.56 9 16.56C13.14 16.56 16.5 13.2 16.5 9.06C16.5 4.92 13.14 1.56 9 1.56Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9206 4.81341C11.6582 4.4905 11.1839 4.42995 10.861 4.69232C10.5381 4.95469 10.4775 5.42897 10.7399 5.75189L12.7884 8.30494H3.75683C3.3431 8.30494 3 8.64804 3 9.06177C3 9.47551 3.3431 9.81861 3.75683 9.81861H12.7783L10.7298 12.3717C10.4674 12.6946 10.5179 13.179 10.8509 13.4312C11.175 13.6859 11.6522 13.6321 11.9206 13.3101L14.7519 9.7694C15.0827 9.35566 15.0827 8.76789 14.7519 8.35414L11.9206 4.81341Z",
    fill: "currentColor",
    className: "accent"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.9bf7002cd71419302f399393fe41c9df.svg";
export { ForwardRef as ReactComponent };